import { useQuery } from '@tanstack/react-query'
import { ctasQueryOptions } from '@/features/marquee/query-options'
import { useTranslation } from '@/translations/i18n'

/**
 * Right-column info card. On desktop it sits beside the form; on mobile it
 * moves above the fields (between the page title and the event name).
 *
 * The CTA count is read from the library rather than written into the copy: it
 * shipped as "the 18-CTA library" against a library that holds 39, and a number
 * kept by hand goes stale the next time the library moves. Same query key as
 * the CTA picker below, so this costs no extra request; until it answers the
 * sentence is rendered without a count rather than claiming zero.
 */
export function EventFormInfoCard() {
	const { t } = useTranslation()
	const { data: ctas } = useQuery(ctasQueryOptions())
	return (
		<aside className='order-first xxl:order-none w-full xxl:w-[560px] rounded-2xl border border-neutral-200 bg-grey-100 p-6'>
			<h2 className='font-medium text-base text-neutral-900'>
				{t('marquee:info_card_title')}
			</h2>
			<ul className='mt-4 flex flex-col gap-3'>
				{[
					t('marquee:info_card_item_1'),
					t('marquee:info_card_item_2'),
					t('marquee:info_card_item_3', { count: ctas?.length ?? 0 })
				].map((item) => (
					<li className='flex items-start gap-3' key={item}>
						<span className='mt-1.5 size-2 shrink-0 rounded-full bg-primary-600' />
						<span className='text-neutral-700 text-sm'>{item}</span>
					</li>
				))}
			</ul>
		</aside>
	)
}
